import { render } from "./BtnBComponent.vue?vue&type=template&id=7ca53b61&scoped=true"
import script from "./BtnBComponent.vue?vue&type=script&lang=js"
export * from "./BtnBComponent.vue?vue&type=script&lang=js"

import "./BtnBComponent.vue?vue&type=style&index=0&id=7ca53b61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca53b61"]])

export default __exports__